import React, { useMemo } from "react";
import { ICarModel } from "../../../interfaces";
import CustomSelect from "../CustomSelect/CustomSelect";

interface CarModelSelectProps {
  carModels: ICarModel[];
  selectedCarModel: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const CarModelSelect: React.FC<CarModelSelectProps> = ({
  carModels,
  selectedCarModel,
  onChange,
  disabled,
}) => {
  const options = useMemo(
    () => carModels.map((m) => ({ value: m.id, label: m.name })),
    [carModels]
  );
  return (
    <CustomSelect
      id="car_model"
      label="Модель"
      placeholder={
        disabled || carModels.length === 0
          ? "Сначала выберите марку"
          : "Выберите модель авто"
      }
      options={options}
      value={selectedCarModel}
      onChange={onChange}
      disabled={disabled || carModels.length === 0}
    />
  );
};

export default CarModelSelect;
